import { useState, useEffect, useRef } from "react";
import { shareViewContentGet } from "../../services/stores/actions/content";

const VideoComponent = ({
  contentId,
  isViews,
  videocallBackPlay,
  onClick,
  ...props
}) => {
  const videoRef = useRef();

  const handlerMouseEnter = (e) => {
    e.preventDefault();
    if (videoRef?.current)
      videoRef.current.setAttribute("controls", "controls");
  };

  const handlerMouseLeave = (e) => {
    e.preventDefault();
    if (videoRef?.current) videoRef?.current?.removeAttribute("controls");
  };

  const [timeoutState, setTimeoutState] = useState(null);

  const HandlerStartCounterSeen = () => {
    setTimeoutState(
      setTimeout(() => {
        shareViewContentGet(contentId, isViews)
          .then((response) => {
            videocallBackPlay();
          })
          .catch((error) => {
            console.log(error);
          });
      }, 4000)
    );
  };

  const HandlerStopCounterSeen = () => {
    clearTimeout(timeoutState);
  };

  useEffect(() => {
    return () => {
      HandlerStopCounterSeen();
    };
  }, [contentId]);

  return (
    <video
      ref={videoRef}
      onMouseEnter={handlerMouseEnter}
      onMouseLeave={handlerMouseLeave}
      onPlay={HandlerStartCounterSeen}
      onContextMenu={(e) => e.preventDefault()}
      onClick={(e) => {
        e.preventDefault();
        if (onClick) onClick();
      }}
      {...props}
    />
  );
};

export default VideoComponent;

export const VideoSecuredComponent = ({ ...props }) => {
  return <video onContextMenu={(e) => e.preventDefault()} {...props} />;
};
